import { Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslatedFormGroup } from '../services/forms.service';

import { ValidationResult } from '../validators';

@Component({
    selector: 'base-form-component',
    template: ''
})
export class FormComponent {    
    form: TranslatedFormGroup
    validationResult: ValidationResult

    submitting: boolean = false

    @Input() error: any    
    @Input('submitting') set submitSetter(value: boolean) {
        this.submitting = value

        if(this.form)
            if(value)
                this.form.disable()
            else
                this.form.enable()
    }

    @Output('onSubmit') submitEvent = new EventEmitter<any>()
    @Output('onNavigate') navigateEvent = new EventEmitter<string>()

    onSubmit() {
        this.validationResult = null

        if(this.form.valid) {
            this.submitEvent.emit(this.form.value)
        } else { 
            this.validationResult = this.form.validate()
        }
    }
}
